import { render } from "./AppButtonResetNav.vue?vue&type=template&id=4a98feac&ts=true"
import script from "./AppButtonResetNav.vue?vue&type=script&lang=ts"
export * from "./AppButtonResetNav.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__